export default __webpack_public_path__ + "static/media/sides-building.479be4fa.png";